import { Pipe, PipeTransform } from '@angular/core';
import { IAttachment } from '../models/attachments.model';

@Pipe({
  name: 'isPreviewable',
  standalone: false,
})
export class IsPreviewablePipe implements PipeTransform {
  private previewableTypes = ['pdf', 'png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'];

  transform(attachment: IAttachment): boolean {
    if (!attachment || !attachment.type) {
      return false;
    }

    return this.previewableTypes.includes(attachment.type.toLowerCase());
  }
}
